import classNames from 'classnames';
import * as classes from './Label.css';
import { AriaRole, ComponentProps, ReactNode } from 'react';
import BaseTypography from '../BaseTypography';
import { Filter, T_KeyValue } from '@/types/app.type';

export interface LabelProps {
  'data-test-id'?: string;
  /**
   * Define the content of the Label.
   * @type string
   * @required
   */
  children: string | ReactNode;
  /**
   * Define the color of the Label.
   * @type ComponentProps<typeof BaseTypography>['color'];
   * @optional
   */
  color?: ComponentProps<typeof BaseTypography>['color'];
  /**
   * Define the custom className.
   * @type string
   * @optional
   */
  className?: string;
  /**
   * Define the component type.
   * @type "span" | "p"
   * @optional
   */
  component?: keyof Pick<React.JSX.IntrinsicElements, 'span' | 'p'>;
  /**
   * Define the Label role.
   * @type "link" | "presentation" | "none"
   * @optional
   */
  role?: Filter<AriaRole, 'link' | 'presentation' | 'none'>;
  name?: string;
  id?: string;
  htmlFor?: string;
  style?: T_KeyValue;
  disabled?: boolean;
}

export function Label(props: LabelProps) {
  // console.log("Component Label ===== ", props?.component)
  return (
    <BaseTypography
      data-test-id={props['data-test-id']}
      role={props.role ?? 'presentation'}
      component={(props.component ?? 'span')}
      color={props.color}
      className={classNames(classes.base, props.className)}
      id={props?.id}
      htmlFor={props?.htmlFor}
    >
      {props.children}
    </BaseTypography>
  );
}
